import {
  Card,
  CardActionArea,
  CardContent,
  Grow,
  Typography,
} from "@material-ui/core"
import { Image, Transformation } from "cloudinary-react"
import { isEmpty } from "lodash"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import path from "~/assets/Sidebar/feather-path-black.svg"
import DraftPublishedBox from "~/components/Common/DraftPublishedBox"
import HoverText from "~/components/Common/HoverText"

import Box from "../../Common/Box"
import useStyles from "./styles"

const CertificationCard = ({ certification }) => {
  const classes = useStyles()

  return (
    <Grow in={true} timeout={350} style={{ transformOrigin: "center" }}>
      <Box className={classes.container}>
        <Card className={classes.root} raised={true} elevation={0}>
          <CardActionArea
            to={`/certifications/${certification.id}/content`}
            component={Link}
          >
            {!isEmpty(certification.badge_image) && (
              <Box className={classes.badgeBox}>
                <Image
                  publicId={certification.badge_image.public_id}
                  style={{
                    verticalAlign: "bottom",
                    height: "140px",
                    width: "140px",
                    borderRadius: "100%",
                  }}
                >
                  <Transformation
                    crop="fill"
                    gravity="auto"
                    aspectRatio="1:1"
                  />
                </Image>
              </Box>
            )}
            {isEmpty(certification.badge_image) && (
              <Box className={classes.cardMedia} />
            )}

            <CardContent>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <Box className={classes.versionBtnBox}>
                  <Typography variant="caption" className={classes.date}>
                    Last Updated {certification?.updated?.format("M/D/YYYY")}
                  </Typography>
                </Box>
              </Box>
              <Box marginTop="8px" height="70px">
                <HoverText
                  variant="h5"
                  className={classes.title}
                  size={50}
                  data={certification?.name}
                />
              </Box>
              <Box
                display="flex"
                marginTop="12px"
                alignItems="center"
                justifyContent="space-between"
              >
                <Box display="flex" alignItems="center">
                  <Typography
                    color="primary"
                    variant="subtitle1"
                    className={classes.lessons}
                  >
                    {certification?.learning_paths_count}
                  </Typography>
                  <img src={path} alt="" className={classes.image} />
                </Box>
                <Box>
                  <DraftPublishedBox
                    published={certification?.published}
                    has_been_published={certification?.has_been_published}
                    archived={0}
                    size={"90px"}
                    clickable
                  />
                </Box>
              </Box>
            </CardContent>
          </CardActionArea>
        </Card>
      </Box>
    </Grow>
  )
}

CertificationCard.propTypes = {
  certification: PropTypes.object,
  learningPathLength: PropTypes.string,
}

export default CertificationCard
